// Claremont McKenna College's majors (#2652). Read on 2026-10-01 from the
// official 2026-2027 Catalog, Majors and Sequences page
// (catalog.claremontmckenna.edu, catoid 43, navoid 9175). One group: CMC
// has no separate schools. Left out: the 3+2 Dual Degree Program (a program,
// not a major), sequences (CMC's minors), off-campus majors students may take
// at another Claremont College, and graduate programs. Film Studies is listed
// by the catalog as "(dual major only)". The catalog names no degree, so
// degree is blank. The KB's majors list was the starting point; the catalog
// wins.
const majors = {
    "slug": "claremont-mckenna-college",
    "read": "2026-10-01",
    "intro": "Every major in CMC's official 2026-2027 Catalog, Majors and Sequences page. The catalog names no degree beside each major, so none is shown here. Sequences (CMC's minors), the 3+2 dual degree program, off-campus majors at the other Claremont Colleges and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "CMC Catalog 2026-2027, Majors and Sequences",
                "url": "https://catalog.claremontmckenna.edu/content.php?catoid=43&navoid=9175"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Economics-Accounting",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null,
                    "note": "Dual major only"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Government",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Integrated Sciences",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Literature",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Middle East Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy and Public Affairs (PPA)",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics and Economics (PPE)",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Policy",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
